import React, { useEffect, useState } from 'react';
import { fetchAllActivities } from '../services/activityService';
import '../style/pages/ActivityLogPage.css';

const ActivityLogPage = () => {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadActivities = async () => {
            try {
                const data = await fetchAllActivities();
                setActivities(data);
            } catch (error) {
                console.error("Failed to fetch activities", error);
            } finally {
                setLoading(false);
            }
        };
        loadActivities();
    }, []);

    return (
        <div className="activity-log-page">
            <h1>Activity Log</h1>
            {loading ? (
                <div className="loading">Loading activities...</div>
            ) : (
                <div className="table-container">
                    <table className="activity-table">
                        <thead>
                            <tr>
                                <th>Date & Time</th>
                                <th>User</th>
                                <th>Action</th>
                                <th>Type</th>
                                <th>Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activities.map((log) => (
                                <tr key={log.id}>
                                    <td>{new Date(log.timestamp).toLocaleString()}</td>
                                    <td>{log.username}</td>
                                    <td><span className={`badge ${log.action.toLowerCase()}`}>{log.action}</span></td>
                                    <td>{log.entityType}</td>
                                    <td>{log.details}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {activities.length === 0 && <div className="no-data">No activities found.</div>}
                </div>
            )}
        </div>
    );
};

export default ActivityLogPage;
